import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import codes from './modules/code'
import settings from './modules/setting'
import transactions from './modules/transaction'
import scmFields from './modules/scm-field'
import snackbar from './modules/snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    codes,
    settings,
    transactions,
    scmFields,
    snackbar
  }
})
